'use client';

import React from 'react';
import { Button, Left } from 'mmds';
import {
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerPanel,
} from '@app/components/ui/drawer/Drawer';
import useUI from '@app/components/ui/state';
import Linker from '@app/components/linker/linker';
import { useParams } from 'next/navigation';
import { Language } from '@app/lib/store-context/Context';
import { ShopifyMenuItem } from '@app/lib/content-structure';
import s from './support-nav.module.css';

export const SupportNav = ({
    supportStructure,
}: {
    supportStructure: ShopifyMenuItem[];
}) => {
    const { lang } = useParams();
    const { openUIKey, toggleUI } = useUI();
    const isDrawerOpen = openUIKey === 'support-menu';
    const menuCallback = {
        toggleMenu: () => toggleUI('main-menu-mobile'),
    };
    return (
        <Drawer
            open={isDrawerOpen}
            onOpenChange={() => toggleUI('support-menu')}
        >
            <DrawerPanel inFrom="left" variant="catalogue-nav">
                <DrawerHeader closeButtonVariant="text">
                    <div className={s.navHeader}>
                        <button
                            onClick={menuCallback.toggleMenu}
                            className={s.navLeftIcon}
                        >
                            <Left />
                        </button>
                        <Button variant="quite" className={s.navHeading}>
                            Support
                        </Button>
                    </div>
                </DrawerHeader>
                <DrawerBody>
                   <div className={s.navItems}>
                        {supportStructure?.map(
                            ({ title, url, items }, index) => {
                                const submenuItems =
                                    items &&
                                    items.map((subItem, subIndex) => (
                                        <Linker
                                            key={subIndex}
                                            href={subItem.url}
                                            title={subItem.title.toLowerCase()}
                                            lang={lang as Language}
                                            className={s.submenuItem}
                                        >
                                            <Button variant="quite">
                                                {subItem.title}
                                            </Button>
                                        </Linker>
                                    ));
                                return (
                                    <>
                                        <Linker
                                            key={index}
                                            href={url}
                                            title={title.toLowerCase()}
                                            lang={lang as Language}
                                        >
                                            <Button variant="quite">
                                                {title}
                                            </Button>
                                        </Linker>
                                        {submenuItems}
                                    </>
                                );
                            }
                        )}
                    </div>
                    <hr className={s.divider} />
                      <div className={s.navItems}>
                         {typeof window !== 'undefined' &&
                            (window as any).zE && (
                                <a
                                    onClick={() =>
                                        (window as any).zE('messenger', 'open')
                                    }
                                    title="click here to contact us via live chat"
                                    lang={lang as Language}
                                >
                                    <Button
                                        variant="text"
                                        icon="right"
                                        textVariantPadding={false}
                                    >
                                        Start Live Chat
                                    </Button>
                                </a>
                            )}
                        <Linker
                            href="https://support.maap.cc/hc/en-us/requests/new"
                            title="click here to contact us"
                            lang={lang as Language}
                        >
                            <Button variant="text" 
                                icon="mail"
                                textVariantPadding={false}>
                                Email Us
                            </Button>
                        </Linker>
                        <Linker
                            href="tel:+61 3 9133 5881"
                            title="click here to contact us via phone"
                            lang={lang as Language}
                        >
                            <Button variant="text" textVariantPadding={false}>
                                Phone +61 3 9133 5881
                            </Button>
                        </Linker>
                    </div>
                </DrawerBody>
            </DrawerPanel>
        </Drawer>
    );
};

export default SupportNav;
